import { render, staticRenderFns } from "./PriceHistory.vue?vue&type=template&id=b59b51a0&lang=pug"
import script from "./PriceHistory.vue?vue&type=script&lang=js"
export * from "./PriceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports